module.exports = __webpack_public_path__ + "img/HZ-T1442.8d4da8ae.jpg";